import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getImageUrl, triggerEvent } from '../../utils';
import { HubHeaderSection, HeaderText } from './styles';

const HeaderSection = ({ editor, data, payload, setPayload, fileService, loading = false }) => {
  const { useAutoSave } = editor;
  const [name, setName] = useState(data.name || '');

  useEffect(() => {
    if (data.name !== name) {
      setPayload({ ...payload, name, immediateSave: false });
      if (useAutoSave) {
        triggerEvent('hub.updated', {
          name,
          uuid: data.uuid,
          fileName: getImageUrl(fileService, data.image, '220x220'),
        });
      }
    }
  }, [name]);

  useEffect(() => {
    if (data.name !== name) {
      setName(data.name);
    }
  }, [data.name]);

  const setupAutogrow = () => {
    const element = document.querySelector('.autogrow');
    if (element) {
      setTimeout(() => {
        window.Autogrow(element);
      }, 100);
    }
  };

  useEffect(() => {
    if (!loading) {
      setupAutogrow();
    }
  }, [loading]);

  useEffect(() => {
    document.addEventListener('toggleDyslexicFont', setupAutogrow);
    return () => document.removeEventListener('toggleDyslexicFont', setupAutogrow);
  }, []);

  return (
    <HubHeaderSection>
      <HeaderText
        rows="1"
        aria-label={i18n.__('node_name_placeholder')}
        placeholder={i18n.__('node_name_placeholder')}
        value={name || ''}
        onChange={(event) => {
          setName(event.target.value);
        }}
        className="autogrow"
      />
    </HubHeaderSection>
  );
};

export default HeaderSection;

HeaderSection.propTypes = {
  editor: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  payload: PropTypes.object.isRequired,
  setPayload: PropTypes.func.isRequired,
  fileService: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};
